import { RunModelFormValues } from "@features/run/RunModelForm"
import { SEED_FIELD_MAX, SEED_FIELD_MIN } from "@features/run/RunModelForm/validation"
import { ContractFamilyInfo } from "@store/authAtoms"
import { UserPermissions } from "@custom-types/user"

export const getEligibleBuildContractOptions = (
  familyKey: string,
  permissions: UserPermissions | undefined,
) => {
  // builders automatically have whatif permission (builder has a superset of abilities versus whatif user)
  const familyInBuild =
    permissions?.build !== undefined
      ? permissions.build.filter((x) => x.families.indexOf(familyKey) > -1)
      : []

  return familyInBuild
}

export const getEligibleWhatIfContractOptions = (
  familyKey: string,
  permissions: UserPermissions | undefined,
) => {
  // builders automatically have whatif permission (builder has a superset of abilities versus whatif user)
  const familyInWhatif =
    permissions?.whatif !== undefined
      ? permissions.whatif.filter((x) => x.families.indexOf(familyKey) > -1)
      : []
  const familyInBuild =
    permissions?.build !== undefined
      ? permissions.build.filter((x) => x.families.indexOf(familyKey) > -1)
      : []

  const merged: ContractFamilyInfo[] = JSON.parse(JSON.stringify(familyInBuild))
  familyInWhatif.forEach((item) => {
    const found = familyInBuild.filter((x) => x.contract_key == item.contract_key)
    if (found.length === 0) merged.push(item)
  })

  return merged
}

export const getEligibleSupportContractOptions = (
  familyKey: string,
  permissions: UserPermissions | undefined,
) => {
  return permissions?.support !== undefined
    ? permissions.support.filter((x) => x.families.indexOf(familyKey) > -1)
    : []
}

export const getDefaultValues = (contractOptions: ContractFamilyInfo[]): RunModelFormValues => {
  const seed = Math.trunc(SEED_FIELD_MIN + Math.random() * (SEED_FIELD_MAX - SEED_FIELD_MIN))

  return {
    run_name: "",
    contract_key: contractOptions?.length == 1 ? contractOptions[0]?.contract_key : null,
    number_of_samplings: Number(import.meta.env.VITE_DEFAULT_SAMPLINGS) || 1000,
    seed,
  }
}
